"use client";

import "@/assets/styles/global.css";

export default function Error({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  return (
    <div className="containerError">
      <h1 className="errorStatus">500</h1>
      <h4 className="titleError">Ошибка сервера, мы уже чиним!</h4>
      <button className="btnError" onClick={() => reset()}>
        Попробуйте еще раз
      </button>
    </div>
  );
}
